import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	labelsDefaultValueLabel: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.labels.labels-default-value-label',
		defaultMessage: 'Default labels',
		description: 'Label above picker for default value for labels field.',
	},
	labelsDefaultValuePickerPlaceholder: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.labels.labels-default-value-picker-placeholder',
		defaultMessage: 'Select labels',
		description: 'Labels to be appended to the labels field default value in the picker widget',
	},
	labelsDefaultValueDisabledTooltip: {
		id: 'issue-type-page.field-associated.field-configuration.labels.labels-default-value-disabled-tooltip',
		defaultMessage: 'You can’t change this field’s default labels',
		description: 'Tooltip shown when the default labels field is disabled and cannot be edited',
	},
});
